export default __webpack_public_path__ + "images/43199719ff4aa83c6bbfe3e85439e4fd.png";